<template>
  <QuestionYesNo
    title="Is Discrete"
    :question="{ options: options, designator: 'is_discrete' }"
    :initValue="initValue"
    @input="handleChange"
  />
</template>

<script>
import QuestionYesNo from '@/components/QuestionYesNo'

export default {
  name: 'PositionIsDiscrete',
  components: {
    QuestionYesNo
  },
  props: {
    value: {
      type: String
    },
    positionId: {
      type: Number
    }
  },
  data () {
    return {
      options: [
        { id: 'true', text: 'true' },
        { id: 'false', text: 'false' }
      ]
    }
  },
  computed: {
    initValue () {
      return this.value
    }
  },
  methods: {
    async handleChange (data) {
      try {
        const value = data.answer
        await this.$network_utils.updatePosition({ position_id: this.positionId, is_discrete: value, active_at: new Date() })
        this.$emit('input', value)
        this.$utils.emit('show_toast', { text: 'הצלחה' })
      } catch (e) {
        console.log(e)
        this.$utils.emit('show_toast', { text: 'failed' })
      }
    }
  }
}
</script>
